export default __webpack_public_path__ + "static/media/IMAGE_2.67ecd8b5.png";